module.exports = __webpack_public_path__ + "img/work.e40ba7b6.svg";